import React, { Component } from 'react';
import styles from './Main.module.css';

import 'katex/dist/katex.min.css';
import { Outlet } from 'react-router-dom';

export default class Main extends Component {
    render() {
        return (
            <div className={styles.Main}>
                <Outlet />
            </div>
        )
    }
}
